import { action } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const TopicFooterMobileDropdown = dt7948.c(class TopicFooterMobileDropdown extends ComboBoxComponent {
  onChange(value, item) {
    item.action && item.action();
  }
  static {
    dt7948.n(this.prototype, "onChange", [action]);
  }
}, [pluginApiIdentifiers("topic-footer-mobile-dropdown"), selectKitOptions({
  none: "topic.controls",
  filterable: false,
  autoFilterable: false
}), classNames("topic-footer-mobile-dropdown")]);
export default TopicFooterMobileDropdown;